import { connect } from 'react-redux';
import { withProps, compose } from 'recompose';

import { handleRequestUpdate } from '../../redux/thunk/requests';
import { getFullRequestById } from '../../redux/selectors';
import Request from '../../components/requests-list-item';

export const RequestDetailsModal = compose(
  connect(
    (state, { payload }) => ({
      ...getFullRequestById(state, payload),
    }),
    { handleRequestUpdate },
  ),
  withProps({
    isOpen: true,
  }),
)(Request);



// WEBPACK FOOTER //
// ./src/modals/request-details/index.js